import { CustomerSelectorCard } from './CustomerSelectorCard';
import { ProductSelectorCard } from './ProductSelectorCard';
import { DocumentPreviewCard } from './DocumentPreviewCard';
import { ConfirmationCard } from './ConfirmationCard';
import { OptionSelectorCard } from './OptionSelectorCard';
import { QuestionCard } from './QuestionCard';
import { DocumentBuilderCard } from './DocumentBuilderCard';
import { OrderSummaryCard } from './OrderSummaryCard';
import { PaymentCard } from './PaymentCard';
import { CapabilityEditorCard } from './CapabilityEditorCard';
import { InsightKpiCard } from './InsightKpiCard';
import { InsightChartCard } from './InsightChartCard';
import { CreateDocumentCtaCard } from './CreateDocumentCtaCard';

type CardComponent = React.ComponentType<{
  data: Record<string, unknown>;
  onSelect: (selection: Record<string, unknown>) => void;
}>;

const CARD_REGISTRY: Record<string, CardComponent> = {
  customer_selector: CustomerSelectorCard as CardComponent,
  product_selector: ProductSelectorCard as CardComponent,
  document_preview: DocumentPreviewCard as CardComponent,
  confirmation: ConfirmationCard as CardComponent,
  option_selector: OptionSelectorCard as CardComponent,
  question_card: QuestionCard as unknown as CardComponent,
  document_builder: DocumentBuilderCard as unknown as CardComponent,
  order_summary: OrderSummaryCard as CardComponent,
  payment: PaymentCard as CardComponent,
  capability_editor: CapabilityEditorCard as unknown as CardComponent,
  insight_kpi: InsightKpiCard as unknown as CardComponent,
  insight_chart: InsightChartCard as unknown as CardComponent,
  create_document_cta: CreateDocumentCtaCard as unknown as CardComponent,
};

interface RenderCardProps {
  cardType: string;
  cardId: string;
  data: Record<string, unknown>;
  onResponse: (cardId: string, cardType: string, selection: Record<string, unknown>) => void;
}

export function RenderCard({ cardType, cardId, data, onResponse }: RenderCardProps) {
  const Component = CARD_REGISTRY[cardType];

  if (!Component) {
    return (
      <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3 my-2 text-sm text-yellow-700">
        Unknown card type: {cardType}
      </div>
    );
  }

  return (
    <Component
      data={data}
      onSelect={(selection) => onResponse(cardId, cardType, selection)}
    />
  );
}

export {
  CustomerSelectorCard,
  ProductSelectorCard,
  DocumentPreviewCard,
  ConfirmationCard,
  OptionSelectorCard,
  QuestionCard,
  DocumentBuilderCard,
  OrderSummaryCard,
  PaymentCard,
  CapabilityEditorCard,
  InsightKpiCard,
  InsightChartCard,
  CreateDocumentCtaCard,
};
